import AboutUs from "pages/Restaurant/AboutUs";

export default function AboutUsPage() {
  return <AboutUs />;
}
